export default __webpack_public_path__ + "static/media/160.9913d694.jpg";